import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { BootstrapModalComponent } from './layout/modal/bootstrap-modal.component';
import { LanguageService, MODULE_PATHS } from './global/services/_app/language/language.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CommonModule } from '@angular/common';
import { BgTooltipComponent, BgTooltipService } from '@Omnissimo/betelgeuse';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, BootstrapModalComponent, BgTooltipComponent, CommonModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit, OnDestroy {
    title = 'senal_angular_fe';
    private readonly onDestory$ = new Subject<void>();

    constructor(
        private readonly languageService: LanguageService,
        private readonly deviceDetectorService: DeviceDetectorService,
            public readonly tooltipService: BgTooltipService
    ) {
        this.languageService.loadTranslations(MODULE_PATHS.CHANGE)
            .pipe(takeUntil(this.onDestory$))
            .subscribe();

        // if (this.deviceDetectorService.isMobile()) {
        //     this.hideBrowserMenu();
        // }
    }

    ngOnInit(): void {
        // Add mobile class to body element based on device detection
        // if (this.deviceDetectorService.isMobile()) {
        //     document.body.classList.add('mobile');
        // } else {
        //     document.body.classList.remove('mobile');
        // }
    }

    ngOnDestroy(): void {
        this.onDestory$.next();
        this.onDestory$.complete();
    }

    public hideBrowserMenu() {
    if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen({ navigationUI: 'hide' })
            .catch(err => {
                console.error(`Error attempting to enable fullscreen: ${err.message} (${err.name})`);
            });
    } else {
        console.warn("Fullscreen API is not supported in this browser");
    }
}
}
